export default "__VITE_ASSET__ad7417d1__"